module.exports = __webpack_public_path__ + "img/Overlay.344ad122.png";